// extracted by mini-css-extract-plugin
module.exports = {"richTextSection":"pbRichText-module--richTextSection--3ulVT","blockImage":"pbRichText-module--blockImage--2CNTP"};